
<header class="row ePM_BG_Green text-white">
	<div class="logoDiv bg-white">
		<a routerLink="/ang/Company/" *ngIf="isSuperAdmin"><img class="logo" [src]="configData.baseUrl + 'Content/Images/logo.png'" /></a>
		<a routerLink="/ang/Company/{{configData.AppConfig.company}}" *ngIf="!isSuperAdmin"><img class="logo" [src]="configData.baseUrl + 'Content/Images/logo.png'" /></a>
	</div>
    
    <div id="header-bar-right" class="mt-md-3">
        <div ngbDropdown class="d-none d-md-inline" *ngIf="announcements.length">
            <a ngbDropdownToggle class="dropdown-toggle font-weight-bold">Company Announcements {{announcements.length}}</a>
            <div ngbDropdownMenu>
                <a ngbDropdownItem *ngFor="let companyAnnouncement of announcements ; index as e"
                   class="dropdown-item" routerLink="/ang/Announcement/{{ companyAnnouncement.CompanyAnnouncementID }}">
                    {{ companyAnnouncement.AnnouncementTitle }}
                </a>
                <a ngbDropdownItem *ngIf="isAdmin" class="dropdown-item" routerLink="/ang/Announcement">
                    Announcement Admin
                </a>
            </div>
        </div>
		<div class="d-inline pull-right text-right" style="padding-right:15px;">
			
			{{configData.AppConfig.companyName}}
			&middot;

			
			<span class="d-none d-md-inline-block" >
				Logged In {{configData.AppConfig.myName}}
				|
			</span>
			
			<a class="text-white text-nowrap" [href]="configData.baseUrl + 'Account/LogOff'"> Logout <i class="fa fa-sign-out"></i></a>
		</div>
    </div>
</header>